<template>
  <div id="seleccion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <v-card flat v-if="tabSelected == 'Capacitacion'">
                <capacitacion-seleccion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></capacitacion-seleccion-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CapacitacionSeleccionTab from "@/modules/capacitacion/views/seleccion/capacitacion/CapacitacionSeleccionTab.vue";
import ContratacionSeleccionTab from "@/modules/capacitacion/views/seleccion/contratacion/ContratacionSeleccionTab.vue";
import AsignacionSeleccionTab from "@/modules/aplicacion/views/seleccion/asignacion/AsignacionSeleccionTab.vue";

export default {
  name: "seleccion-sub-tab-cap",

  components: {
    CapacitacionSeleccionTab,
    ContratacionSeleccionTab,
    AsignacionSeleccionTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Capacitacion"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
    },
  },
};
</script>
